module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-easy-invoicing-e34d33a47473403726b4775090cc8d6b.png";